import { IsOptional, IsString } from 'class-validator';
import type { ICommonAuthResp, IScopeResp } from '../auth/Auth.types';
import type { IAccessControl } from '../accessControl/AccessControl.types';

export interface IUser {
  id: string;
  azureId: string;
  givenName: string;
  familyName: string;
  email: string;
  title?: string;
  avatar?: string;
  /** Set by the auth service; only returned when inactive users are included. */
  isActive?: boolean;
  /** Set by the auth service for service principals rather than people. */
  isApplication?: boolean;
}

/**
 * The name unions are parameterised so consumers can narrow them to their own
 * vocabulary (see the frontend's Group/Role/Scope); the shape stays shared.
 */
export interface IMetadata<G = string, R = string, S = string> {
  groups: ICommonAuthResp<G>[];
  roles: ICommonAuthResp<R>[];
  scopes: IScopeResp<S>[];
  accessControls: IAccessControl[];
}

export interface IUserWithMetadata<
  G = string,
  R = string,
  S = string,
> extends IUser, IMetadata<G, R, S> {}

export interface IMentionedUser {
  id: string;
  slackId: string;
  fullName: string;
}

export class UserDTO
implements IUser {
  @IsString()
    id: string;

  @IsString()
    azureId: string;

  @IsString()
    givenName: string;

  @IsString()
    familyName: string;

  @IsString()
    email: string;

  @IsString()
  @IsOptional()
    title?: string;

  @IsString()
  @IsOptional()
    avatar?: string;
}
